import React from "react"

function FormLabel({ text, className, notice }) {
  return (
    <div className={"textforinput marginTop10px " + className}>
      <p>{text}</p>
      {notice &&
        notice.map((noticeText, i) => {
          return (
            <React.Fragment key={i}>
              <span className="InputFieldNote">{noticeText}</span> <br />
            </React.Fragment>
          )
        })}
    </div>
  )
}
export default FormLabel
